export const MobileMenuController = () => {
  toggleMenu();
  setHeight();
  menuPanels();
}


const setHeight = () => {
  let maxHeight = 0;

  $('div[data-level]').not('[data-level="1"]').each(function(){
    const thisH = $(this).find('> ul').height();

    if (thisH > maxHeight) {
      maxHeight = thisH;
    }
  });

  $('.mobile-menu__primary').height(maxHeight);
}



const toggleMenu = () => {
  const menu = $('.mobile-menu');
  const button = $('.nav-toggle');

  button.on('click', (e) => {
    if(button.attr('aria-expanded') === 'false') {
      showMenu(button, menu)
    } else {
      hideMenu(button, menu)
    }
  })
}


const showMenu = (button, menu) => {
  button.attr('aria-expanded', true)
  menu.addClass('show')
}


const hideMenu = (button, menu) => {
  button.attr('aria-expanded', false)
  menu.removeClass('show');
}


const resetMenu = () => {
  $('div[data-level="1"]').removeClass('hide').addClass('show');
  $('div[data-level]').not('[data-level="1"]').removeClass('show').removeClass('sub-active').addClass('hide');
}

const menuPanels = () => {
  $('.mobile-menu-item.has-submenu').on('click', (e) => {
    const $this = $(e.currentTarget);
    $('.mobile-menu-item').not($this).find(' > div[data-level="2"]').removeClass('show').addClass('hide');
    $this.closest('.mobile-menu-item').find(' > div[data-level="2"]').removeClass('hide').addClass('show');
    $('div[data-level="1"]').addClass('hide');
  });

  $('.submodule.has-submenu').on('click', (e) => {
    const $this = $(e.currentTarget);
    e.stopPropagation();

    $('.submodule').not($this).find(' > div[data-level="3"]').removeClass('show').addClass('hide');
    $this.closest('.submodule').find(' > div[data-level="3"]').removeClass('hide').addClass('show');

    $this.closest('div[data-level="2"]').addClass('sub-active');
  });

  $('.submodule.back').on('click', (e) => {
    const $this = $(e.currentTarget);
    e.stopPropagation();
    $this.closest('.mobile-menu-item').find(" > div[data-level='2']").removeClass('show').addClass('hide').removeClass('sub-active');
    $('div[data-level="1"]').removeClass('hide');
  });

  $('.back').not('.submodule').on('click', (e) => {
    const $this = $(e.currentTarget);
    e.stopPropagation();
    $this.closest('.submodule').find(' > div[data-level="3"], > div[data-level="2"]').removeClass('show').addClass('hide');
    $this.closest('div[data-level="2"]').removeClass('sub-active');
  });
}



// WEBPACK FOOTER //
// ./src/js/controllers/MobileMenuController.js